import { useEffect, useState } from "react";
import { Platform } from "react-native";

const getScrollbarWidth = (): number => {
  if (Platform.OS !== "web") return 0;
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  document.body.appendChild(outer);
  const inner = document.createElement("div");
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode?.removeChild(outer);
  return scrollbarWidth;
};

export const useScrollbarWidth = () => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0);

  useEffect(() => {
    if (Platform.OS === "web") {
      setScrollbarWidth(getScrollbarWidth());
    }
  }, []);

  return scrollbarWidth;
};
